import { Loading } from "wup-module1-base";
import { useNavigate } from "react-router-dom";
import { Card, Container, Button } from "react-bootstrap";
import { useState, useEffect } from "react";
import { M1_AnswersTypeEnum, M1_QuestionTypeEnum } from "../../Constants/Enums";

const SurveySummary = ({
  showPreviousCard,
  surveyData,
  answers,
  isFinal,
  downloadPDF,
  survType,
  isSubmitAvailable,
  isSubmitLoading,
  voucherAmount,
  setAnswers,
  getValues
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!!answers && Object.keys(answers).length === 0) {
      setAnswers(getValues());
    }
  }, [answers])

  function goBack() {
    navigate(`/`);
  }

  function getLabelName(string) {
    let separatedArray = string.split(";");
    return separatedArray[0];
  }

  function getContentById(id, array) {
    const foundItem = array.find((item) => item.id === id);
    return foundItem ? foundItem.content : null;
  }

  function getAnswerTextForMultiselect(id, question_options, question) {
    if (question.validation_rules) {
      let validationObject = JSON.parse(question.validation_rules);
      if (validationObject.displayType === "1") {
        return answers[`${question.selector_id}`];
      }
    }
    const trueAnswers = Object.keys(answers).filter(
      (key) => key.startsWith(id + "_") && answers[key] === true
    );

    const trueAnswersValues = trueAnswers.map((answerKey) => {
      const id = parseInt(answerKey.split("_")[1]);
      return getContentById(id, question_options);
    });

    return trueAnswersValues.join(", ");
  }

  const renderAnswer = (question_id, question_answers) => {
    let answersArray = [];
    let i = 1;
    let elNumber = 5;
    let answer = "";

    while (i < elNumber) {
      answer = "";
      question_answers.forEach((obj, index) => {
        if (
          answers.hasOwnProperty(`${question_id}_${obj.id}_${i}`) &&
          answers[`${question_id}_${obj.id}_${i}`] !== ""
        ) {
          if (obj.content.includes(";5")) {
            let parsed_answers = JSON.parse(obj.many_answers_column);
            let option = parsed_answers.find(function (parsed_answers) {
              return (
                parsed_answers.value ===
                answers[`${question_id}_${obj.id}_${i}`]?.toString()
              );
            });
            answer +=
              ` <span class="question-label">${getLabelName(
                obj.content
              )}: </span>` +
              option?.label +
              `</br>`;
          } else {
            answer +=
              ` <span class="question-label">${getLabelName(
                obj.content
              )}: </span>` +
              answers[`${question_id}_${obj.id}_${i}`] +
              `</br>`;
          }
        } else if (
          answers.hasOwnProperty(`answer_${question_id}_${obj.id}_${i}`) &&
          answers[`answer_${question_id}_${obj.id}_${i}`] !== ""
        ) {
          answer +=
            ` <span class="question-label">${getLabelName(
              obj.content
            )}: </span>` +
            answers[`answer_${question_id}_${obj.id}_${i}`] +
            `</br>`;
        }
      });

      for (const key in answers) {
        if (key === `${question_id}_table_${i}`) {
          answer += `<div>${answers[key]}</div>`;
        }
      }
      if (answer !== "") {
        answersArray.push(answer);
        elNumber++;
      }
      i++;
    }
    return answersArray;
  };

  function getAnswerText(key) {
    let foundAnswer;
    if (answers.hasOwnProperty(key)) {
      foundAnswer = answers[key];
    } else {
      return "";
    }

    if (foundAnswer) {
      if (typeof foundAnswer === "boolean") {
        foundAnswer = foundAnswer ? "Tak" : "Nie";
      }
    }

    return foundAnswer && typeof foundAnswer === "string" ? foundAnswer : "";
  }

  return (
    <>
      <Card.Body className="summary-card survey-screen">
        {isLoading ? (
          <Loading />
        ) : (
          surveyData && !!answers &&
          Object.keys(answers).length > 0 &&
          surveyData.map((surveyItem) =>
            surveyItem.questions.map((question) => (!!question?.visible_in_summary && (
              <div key={question.id}>
                {question.type !== M1_QuestionTypeEnum.Content.value ? (
                  <>
                    {question.type === M1_QuestionTypeEnum.Table.value &&
                      renderAnswer(question.selector_id, question.answers)
                        .length > 0 ? (
                      <div>
                        <h6 className="question">{question.name}</h6>
                        <div class="answer">
                          {renderAnswer(
                            question.selector_id,
                            question.answers
                          )?.map((answer, index) => (
                            <div
                              key={index}
                              dangerouslySetInnerHTML={{ __html: answer }}
                            />
                          ))}
                        </div>
                      </div>
                    ) : question.type ===
                      M1_QuestionTypeEnum.OptionList.value ? (
                      <div>
                        <h6 className="question">{question.name}</h6>
                        <div className="answer">
                          {getAnswerTextForMultiselect(
                            question.selector_id,
                            question.answers,
                            question
                          )}
                        </div>
                      </div>
                    ) : getAnswerText(question.selector_id) !== "" ? (
                      <div>
                        <h6 className="question">{question.name}</h6>
                        <div className="answer">
                          {getAnswerText(question.selector_id)}
                        </div>
                      </div>
                    ) : null}
                  </>
                ) : null}
              </div>
            )))
          )
        )}
      </Card.Body>
      <Card.Footer className="bg-white">
        {isFinal ? (
          <>
            <Button
              className="btn-back"
              variant="secondary mr-1"
              onClick={goBack}
            >
              Powrót
            </Button>
            <Button
              className="btn-next"
              variant="primary"
              onClick={downloadPDF}
            >
              Pobierz PDF
            </Button>
          </>
        ) : (
          <>
            <Button
              className="btn-back"
              variant="secondary mr-1"
              onClick={showPreviousCard}
            >
              Wstecz
            </Button>
            {!!isSubmitAvailable && (
              <>
                {!!isSubmitLoading ? (
                  <Button className="btn-next" variant="primary">
                    <Loading size="sm" className="px-3" variant="light" />
                  </Button>
                ) : (
                  <Button className="btn-next" variant="primary" type="submit">
                    {survType === 1 && `Wyślij do doradcy`}
                    {survType === 2 && `Zatwierdź`}
                    {survType === 3 && `Zamów bony`}
                    {survType === 4 && `Zamów ${voucherAmount} bonów`}
                  </Button>
                )}
              </>
            )}
          </>
        )}
      </Card.Footer>
    </>
  );
};

export default SurveySummary;
